<template><div><h1 id="auswertungen-nachlass" tabindex="-1"><a class="header-anchor" href="#auswertungen-nachlass"><span>Auswertungen Nachlass</span></a></h1>
<p>Die Referenz beschreibt Auswertungen und Statistiken aus dem Bereich Nachlass.</p>
<p><strong>Mehr dazu</strong>
<RouteLink to="/manual/individualfundraising/nachlass.html">Nachlass</RouteLink>
<RouteLink to="/referenz/refstat/ft.refstat.auswertungnachlass.html">Auswertung Nachlass</RouteLink></p>
</div></template>


